export default {
    initCellHeight: 35,
    initCellWidth: 120,
}
